import React, { useState } from "react";
import { Row, Col, Form } from "react-bootstrap";
import { VscReplace } from "react-icons/vsc";
import { BiEdit } from "react-icons/bi";
import EfisModal from "../../../../components/UI/EfisModal/EfisModal";
import HtmlEditor from "../../../../components/UI/HtmlEditorInput/HtmlEditor";
import useSubstituirTexto from "../../InputsProximaAtividade/hooks/useSubstituirTexto";
import FormAlert from "../../../../components/UI/FormAlert/FormAlert";
// import FormRelCircunstanciado from "./FormRelCircunstanciado";
import FormAtividades from "../../InputsProximaAtividade/components/FormAtividades";

const TelaAtividadeAIEspecial = ({ formik, dadosOs, atividade }) => {
  const { substituirTextoComunicado, show, setShow, substituirIsLoading, substituirData, substituirErrors } =
    useSubstituirTexto({ dadosOs, formik });
  const [showTextoAtividade, setShowTextoAtividade] = useState(true);

  const trocarTextoFormik = () => {
    formik.setValues((curr) => ({
      ...curr,
      textoDocumento: formik.values.textoDocumento
        ? formik.values.textoDocumento.replace("[NUMOS]", dadosOs.sequencial)
        : "",
    }));
  };

  return (
    <>
      <FormAlert
        formik={formik}
        data={substituirData}
        errors={substituirErrors}
        isLoading={substituirIsLoading}
        dismissible
      />
      <EfisModal
        show={show.show}
        title="Texto da Atividade"
        size="lg"
        closeHandler={() => setShow({ show: false })}
        primaryLabelVisible={false}
        secondaryLabel="Fechar"
        body={show.body}
      />
      <br />

      {(atividade.siglaAtividade === "AUINCIAIES" ||
        atividade.siglaAtividade === "AUTEREREES" ||
        atividade.siglaAtividade === "AUTEREAIES") && (
        <Row>
          <Form.Group as={Col} sm={12} md={12}>
            <FormAtividades formik={formik} acaoFiscal={dadosOs.acaoFiscal} siglaAtividade={atividade.siglaAtividade} />
          </Form.Group>
        </Row>
      )}

      {atividade.siglaAtividade !== "AIE0" && (
        <Row className="mt-2">
          <Col>
            <hr />
            <strong>Texto da Atividade</strong>
            <BiEdit
              className="btn-lg text-danger pa-0 p-0 btn btn-bg-transparent ml-2"
              title={showTextoAtividade ? "Editar Texto" : "Fechar Edição"}
              onClick={() => {
                setShowTextoAtividade(!showTextoAtividade);
                trocarTextoFormik();
              }}
            />
            <VscReplace
              className="btn-lg  text-danger pa-0 p-0 btn btn-bg-transparent ml-2"
              title="Visualizar texto com substituições"
              onClick={() => substituirTextoComunicado(true, formik.values.textoDocumento)}
            />

            {!showTextoAtividade && <HtmlEditor formik={formik} field="textoDocumento" rows="5" />}
            <hr hidden={!showTextoAtividade} />
          </Col>
        </Row>
      )}
    </>
  );
};

export default TelaAtividadeAIEspecial;
